import React, { useState, useEffect } from "react";
import axios from "axios";
import "./HotelFinalBooking.css";
import { useNavigate } from "react-router-dom";
import { BsInfoCircleFill } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { Container, Row, Col } from "react-bootstrap";
import { FaChevronLeft } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
// import HotelPromoCodes from "./HotelPromoCodes";
import { FaArrowLeft } from "react-icons/fa";
import FlightListSkeleton from "../../Flight/FlightList/FlightListSkeleton";
import HotelTechnicalError from "../HotelNotFound/HotelTechnicalError";
import HotelNotFound from "../HotelNotFound/HotelNotFound";
import HotelReviewPage from "./HotelReviewPage";

import HotelReviewPageMobile from "./HotelReviewPageMobile";
import { toast } from "react-toastify";
import HotelFinalBookingSkeleton from "./HotelFinalBookingSkeleton";
import Swal from "sweetalert2";
import PromoCode from "../../Flight/FlightDetail/PromoCode";

const HotelFinalBooking = () => {
  const [hotelPreBookData, setPreBookData] = useState(null);
  const [hotelBookData, setHotelBookData] = useState(null);
  const [roomsConfig, setRoomsConfig] = useState([]);
  const [showGSTFields, setShowGSTFields] = useState(false);
  const [guestInfo, setGuestInfo] = useState([]);
  const [contactNumber, setContactNumber] = useState("");
  const [email, setEmail] = useState("");
  const [gstCompanyName, setGstCompanyName] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [paymentInitializing, setPaymentInitializing] = useState(false);
  const [bookingProcessing, setBookingProcessing] = useState(false);
  const [error, setError] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showReviewModalMobile, setShowReviewModalMobile] = useState(false);
  const [checkIn, setCheckIn] = useState(null);
  const [checkOut, setCheckOut] = useState(null);


  const location = useLocation();
  useEffect(() => {
    const data = localStorage.getItem("hotelRoomsConfig");
    const parsed = JSON.parse(data);
    setRoomsConfig(parsed);
  }, []);
  useEffect(() => {
    const storedConfig = localStorage.getItem("hotelRoomsConfig");
    if (storedConfig) {
      const parsed = JSON.parse(storedConfig);
      setRoomsConfig(parsed);

      const newGuestInfo = parsed.map((room) => {
        const passengers = [];
        for (let i = 0; i < (room.adults || 0); i++) {
          passengers.push({
            Title: "",
            FirstName: "",
            LastName: "",
            PaxType: 1,
            PAN: "",
            PassportNo: "",
            CompanyName: "",
            CorporateID: "",
            Errors: { FirstName: "", LastName: "", Title: "" },
          });
        }
        for (let i = 0; i < (room.children || 0); i++) {
          passengers.push({
            Title: "",
            FirstName: "",
            LastName: "",
            PaxType: 2,
            Errors: { FirstName: "", LastName: "", Title: "" },
          });
        }
        return { HotelPassenger: passengers };
      });

      setGuestInfo(newGuestInfo);
    }
  }, [location]);

  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const checkInDate = localStorage.getItem("hotelCin");
    const checkOutDate = localStorage.getItem("hotelCout");

    console.log("Check-in:", checkInDate);
    console.log("Check-out:", checkOutDate);

    setCheckIn(checkInDate);
    setCheckOut(checkOutDate);
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem("hotelId");
    const storeBookingCode = localStorage.getItem("bookingCode");
    const storeBatchKey = localStorage.getItem("batchKey");
    const storedRoom = JSON.parse(localStorage.getItem("rooms"));

    const preBookRequestData = {
      hid: storedData,
      BookingCode: storeBookingCode,
      // BatchKey: storeBatchKey,
      // Rooms: storedRoom,
    };

    // const fetchHotelPreBook = async () => {
    //   try {
    //     const response = await axios.post(
    //       "https://admin.travelsdata.com/api/Hotel/PreBook",
    //       preBookRequestData
    //     );

    //     console.log("Hotel PreBook:", response.data);

    //     if (response.data?.success === false) {
    //       // Check if message says "No Available rooms..."
    //       if (response.data?.message?.includes("No Available rooms")) {
    //         setNotFound(true);
    //       } else {
    //         setError(true);
    //       }
    //     } else {
    //       setPreBookData(response.data);
    //     }
    //   } catch (err) {
    //     console.error("API failed:", err);
    //     setError(true);
    //   }
    // };
    const fetchHotelPreBook = async () => {
      try {
        const response = await axios.post(
          "https://admin.travelsdata.com/api/Hotel/PreBook",
          preBookRequestData
        );

        console.log("Hotel PreBook:", response.data);

        const success = response.data.success === true;
        if (!success) {
          toast.error(
            response.data.message ||
              "Unable to proceed with booking. Please try again."
          );
          navigate(-2);
          return;
        }

        // const data = response.data.data;
        // if (!data || !data.rooms || data.rooms.length === 0 || !data.HotelDetail) {
        //   toast.error("Rooms are not available or invalid response. Please try again.");
        //   navigate(-2);
        //   return;
        // }

        setPreBookData(response.data);
      } catch (err) {
        console.error("Hotel PreBook API failed:", err);
        toast.error(err?.message || "Something went wrong. Please try again.");
        navigate(-2);
      }
    };
    fetchHotelPreBook();
  }, []);

  const handleGuestInputChange = (roomIndex, passengerIndex, field, value) => {
    setGuestInfo((prev) => {
      const updated = [...prev];
      const passenger = updated[roomIndex].HotelPassenger[passengerIndex];

      passenger[field] = value;

      // Inline validation
      if (field === "FirstName") {
        passenger.Errors.FirstName = value.trim()
          ? ""
          : "First Name is required";
      }
      if (field === "LastName") {
        passenger.Errors.LastName = value.trim() ? "" : "Last Name is required";
      }
      if (field === "Title") {
        passenger.Errors.Title = value.trim() ? "" : "Title is required";
      }

      return updated;
    });
  };

  const handleGSTCheckboxChange = () => {
    setShowGSTFields(!showGSTFields);
  };

  const navigate = useNavigate();



  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (bookingId) => {
    setPaymentInitializing(true); // Start payment initialization

    const res = await loadRazorpayScript();
    if (!res) {
      Swal.fire({
        icon: "error",
        title: "Razorpay SDK Failed",
        text: "Please refresh and try again.",
      });
      setPaymentInitializing(false);
      return;
    }

    try {
      setShowReviewModalMobile(false);
      setShowReviewModal(false);

      // ✅ STEP 1: Calculate final payable amount (with coupon discount if applied)
      const baseAmount = parseInt(
        hotelPreBookData?.data?.HotelResult[0]?.Rooms[0]?.TotalFare || 0
      );

      const finalAmount = Math.round(
        baseAmount - (selectedCoupon ? selectedCoupon.discount : 0)
      );

      // ✅ STEP 2: Create Razorpay order
      const { data: orderData } = await axios.post(
        "https://admin.travelsdata.com/api/Hotel/CreateOrder",
        {
          amount: finalAmount,
        }
      );

      if (orderData.success === false) {
        Swal.fire({
          icon: "error",
          title: "Order Creation Failed",
          text: "Could not initiate payment. Please try again.",
        });
        setPaymentInitializing(false);
        return;
      }

      // ✅ STEP 3: Razorpay options
      const options = {
        key: orderData.data.key,
        amount: orderData.data.amount,
        currency: orderData.data.currency,
        name: "Innovate Blues",
        description: "Innovate Blues Hotel Booking",
        image: "/Images/tripgoo.png",
        order_id: orderData.data.order_id,
        handler: async function (response) {
          try {
            // ✅ STEP 4: Verify payment
            const { data: verifyData } = await axios.post(
              "https://admin.travelsdata.com/api/Hotel/VerifyPayment",
              {
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id,
                type: "web",
              }
            );

            if (verifyData.success) {
              toast.success("✅ Payment Successful!");
              setBookingProcessing(true);
              handleHotelBookNow(bookingId);
            } else {
              Swal.fire({
                icon: "error",
                title: "Payment Verification Failed",
                text: "Please contact support.",
              });
            }
          } catch (verifyErr) {
            console.error("Verification error:", verifyErr);
            Swal.fire({
              icon: "error",
              title: "Verification Error",
              text: "An error occurred while verifying your payment.",
            });
          } finally {
            setPaymentInitializing(false);
          }
        },
        prefill: {
          name: "Innovate Blues",
          email: "support@innovateblues.com",
          contact: "+91 9718278968",
        },
        theme: { color: "#1d489f" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      setPaymentInitializing(false); // Hide loading when Razorpay modal opens
    } catch (err) {
      console.error("Order creation error:", err);
      Swal.fire({
        icon: "error",
        title: "Payment Error",
        text: "Something went wrong while creating the order.",
      });
      setPaymentInitializing(false);
    }
  };

  const handleHotelBookNow = async (bookingId) => {
    localStorage.setItem("bookingId", bookingId);

    setPaymentInitializing(true);

    let hasError = false;

    const isSamePaxAllowed = hotelPreBookData?.data?.ValidationInfo?.SamePaxNameAllowed;

    // Validate all guest inputs
    const updatedGuestInfo = [...guestInfo].map((room) => {
      const leadAdult = room.HotelPassenger[0];
      const updatedPassengers = room.HotelPassenger.map((passenger, pIdx) => {
        const updatedPassenger = { ...passenger };

        // If same pax name is allowed, use the first adult's details for all others in the room
        if (isSamePaxAllowed && pIdx > 0) {
          updatedPassenger.Title = leadAdult.Title;
          updatedPassenger.FirstName = leadAdult.FirstName;
          updatedPassenger.LastName = leadAdult.LastName;
        }

        if (!updatedPassenger.Title?.trim()) {
          updatedPassenger.Errors.Title = "Title is required";
          hasError = true;
        } else {
          updatedPassenger.Errors.Title = "";
        }

        if (!updatedPassenger.FirstName?.trim()) {
          updatedPassenger.Errors.FirstName = "First Name is required";
          hasError = true;
        } else {
          updatedPassenger.Errors.FirstName = "";
        }

        if (!updatedPassenger.LastName?.trim()) {
          updatedPassenger.Errors.LastName = "Last Name is required";
          hasError = true;
        } else {
          updatedPassenger.Errors.LastName = "";
        }

        return updatedPassenger;
      });

      return { HotelPassenger: updatedPassengers };
    });

    setGuestInfo(updatedGuestInfo);

    if (!contactNumber.trim()) {
      alert("Contact number is required");
      hasError = true;
    }
    if (!email.trim()) {
      alert("Email is required");
      hasError = true;
    }

    if (hasError) {
      setPaymentInitializing(false);
      return;
    }

    const hotelCode = localStorage.getItem("hotelId");
    const bookingCode = localStorage.getItem("bookingCode");
    const batchKey = localStorage.getItem("batchKey");
    const netAmount =
      hotelPreBookData?.data?.HotelResult[0].Rooms[0]?.TotalFare || 0;
    const cityCode = hotelPreBookData?.data?.HotelDetail?.city_code || "";

    const hotelRoomsDetails = updatedGuestInfo.map((room) => {
      let foundLead = false;

      const HotelPassenger = room.HotelPassenger.map((passenger) => {
        const isAdult = passenger.PaxType === 1;
        const isLead = !foundLead && isAdult;
        if (isLead) foundLead = true;

        return {
          Title: passenger.Title,
          FirstName: passenger.FirstName,
          LastName: passenger.LastName,
          PaxType: passenger.PaxType,
          LeadPassenger: isLead,
          Age: passenger.PaxType === 2 ? passenger.Age || 0 : 0,
          Email: null,
          MiddleName: "",
          PassportNo: null,
          PassportIssueDate: null,
          PassportExpDate: null,
          Phoneno: null,
          PaxId: 0,
          GSTCompanyAddress: null,
          GSTCompanyContactNumber: null,
          GSTCompanyName: null,
          GSTNumber: null,
          GSTCompanyEmail: null,
          PAN: "",
        };
      });

      return { HotelPassenger };
    });

    const requestData = {
      UserEmail: email,
      UserPhone: contactNumber,
      CouponId: selectedCoupon ? selectedCoupon.id : null,
      Type: "web",
      CheckIn: checkIn,
      CheckOut: checkOut,
      BookingCode: bookingCode,
      CityCode: cityCode,
      NetAmount: Math.round(netAmount),
      HotelCode: hotelCode,
      // BatchKey: batchKey,
      HotelRoomsDetails: hotelRoomsDetails,
    };

    console.log(
      "City Code from HotelDetail:",
      hotelPreBookData?.data?.HotelDetail?.city_code
    );

    try {
      const response = await axios.post(
        "https://admin.travelsdata.com/api/Hotel/Book",
        requestData
      );
      setHotelBookData(response.data);
      localStorage.setItem(
        "BookingID",
        response.data.data.BookResult.BookingId
      );
      if (response.data.success === true) {
        navigate("/hotelvoucher");
      }
      console.log("Hotel Booked:", response.data);
      if (response.data && response.data.success === false) {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error("Hotel Booking Failed:", err);
      toast.error(err);
      navigate("/hoteltechnicalerror");
      // navigate(-2);
    } finally {
      setPaymentInitializing(false);
      setBookingProcessing(false);
    }
  };
  const ValidationInfo = hotelPreBookData?.data?.ValidationInfo || {};

  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [loadingCoupons, setLoadingCoupons] = useState(true);
  const [errorCoupons, setErrorCoupons] = useState(null);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const payload = { type: "flights" };
        const response = await axios.post(
          "https://admin.travelsdata.com/api/User/CouponCode",
          payload
        );

        if (response.data?.success) {
          setCoupons(response.data.data || []);
        } else {
          setErrorCoupons("Failed to fetch coupons");
        }
      } catch (err) {
        console.error("Error fetching coupons:", err);
        setErrorCoupons("Error fetching data");
      } finally {
        setLoadingCoupons(false);
      }
    };

    fetchCoupons();
  }, []);



  return (
    <div>
      {error ? (
        <HotelTechnicalError />
      ) : notFound ? (
        <HotelNotFound />
      ) : hotelPreBookData ? (
        <>
          <div className="hotelPreBook" style={{ position: "relative" }}>
            <div
              className="hotelFinalBooking_MainBg"
              style={{ height: "150px" }}
            ></div>
            <div className="hotelFinalBooking_Main">
              <div className="hotelFinalBooking_Containers">
                <Container>
                  <Row>
                    <Col md={9}>
                      <div className="hotelFinalBooking_ReviewBooking">
                        <div className="hotelFinalBooking_reviewBook">
                          <Link to="/hoteldetailsmain">
                            <span style={{ color: "white" }}>
                              <FaChevronLeft />
                            </span>
                          </Link>
                          <h3>Review Your Booking</h3>
                        </div>
                        {/* <div className="hotelFinalBooking_reviewBook">
                          <span>
                            <BsInfoCircleFill />
                          </span>
                          <h4>Fare Rules</h4>
                        </div> */}
                      </div>

                      <div className="hotelFinalBooking_hotelDetails">
                        <div className="hotelFinalBooking_hotelNameAdd">
                          <div className="hotelListingstyling-name hotelFinalBooking-name">
                            {hotelPreBookData?.data?.HotelDetail?.name}
                            <div
                              className="rating-score"
                              style={{ textAlign: "center", fontSize: "18px" }}
                            >
                              {[...Array(5)].map((_, index) => (
                                <span
                                  key={index}
                                  style={{
                                    color:
                                      index <
                                      Number(
                                        hotelPreBookData?.data?.HotelDetail
                                          ?.star_rating
                                      )
                                        ? "#FFD700"
                                        : "#ccc",
                                  }}
                                >
                                  ★
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="hotel-Address">
                            <CiLocationOn />{" "}
                            <span>
                              {hotelPreBookData?.data?.HotelDetail?.address}
                            </span>
                          </div>
                        </div>

                        <Row className="hotelFinalBooking_rowCols">
                          <Col md={4} className="hotelFinalBooking_Col1">
                            <img
                              src={
                                hotelPreBookData?.data?.HotelDetail?.images?.[0] ||
                                "https://cdn01.metrotvnews.com/dynamic/content/2025/05/13/ba4CzPQY/a_6822c7db85750.jpg?w=720"
                              }
                              alt=""
                            />
                          </Col>
                          <Col md={8} className="hotelFinalBooking_Col2">
                            <div className="hotelFinalBooking_CheckinDetails">
                              <div className="hotelFinalBooking_checkIn">
                                <h6>CHECK-IN </h6>
                                <h3>
                                  {checkIn
                                    ? new Date(checkIn).toLocaleDateString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        }
                                      )
                                    : ""}
                                </h3>
                              </div>
                              <div
                                style={{
                                  width: "80px",
                                  height: "2px",
                                  backgroundColor: "black",
                                }}
                              ></div>
                              <div className="hotelFinalBooking_checkOut">
                                <h6>CHECK-OUT</h6>
                                <h3>
                                  {checkOut
                                    ? new Date(checkOut).toLocaleDateString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        }
                                      )
                                    : ""}
                                </h3>
                              </div>

                              <Link to="/hoteldetailsmain">
                                <div className="hotelFinalBooking_changeRoom">
                                  CHANGE ROOM
                                </div>
                              </Link>
                            </div>

                            <div className="hotelFinalBooking_roomsGuests">
                              <h6>ROOMS & GUESTS</h6>
                              <h6>
                                <span style={{ fontWeight: "bold" }}>
                                  {roomsConfig.length}
                                </span>{" "}
                                <span className="hotelFinalBooking_roomsGuests_Span">
                                  Rooms
                                </span>{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {roomsConfig.reduce(
                                    (acc, r) =>
                                      acc + (r.adults || 0) + (r.children || 0),
                                    0
                                  )}
                                </span>{" "}
                                <span className="hotelFinalBooking_roomsGuests_Span">
                                  Guests
                                </span>
                              </h6>
                            </div>
                          </Col>
                        </Row>

                        <div className="hotelFinalBooking_roomType">
                          <h6>{hotelPreBookData?.data?.rooms[0]?.Name}</h6>
                          <div>
                            {/* <span style={{ fontWeight: "bold" }}>1</span> Room */}
                            <span style={{ fontWeight: "bold" }}>
                              {roomsConfig.length}
                            </span>{" "}
                            <span className="hotelFinalBooking_roomsGuests_Span">
                              Rooms
                            </span>{" "}
                          </div>

                          <div className="hotelFinalBooking_inclusion">
                            Inclusions
                          </div>
                        </div>
                      </div>

                      <div className="traveller_info hotelFinalBooking_guestInfo">
                        <h4>Guest Information</h4>

                        {roomsConfig.map((room, roomIndex) => (
                          <React.Fragment key={roomIndex}>
                            <Row>
                              <Col
                                sm={2}
                                className="hotelFinalBooking_guestRoomsCol"
                              >
                                <label className="hotelFinalBooking_guestLabel hotelFinalBooking_guestRooms">
                                  Room {roomIndex + 1}
                                </label>
                              </Col>
                            </Row>

                            {[...Array(room.adults || 0)].map(
                              (_, adultIndex) => {
                                if (ValidationInfo.SamePaxNameAllowed && adultIndex > 0) return null;
                                return (
                                  <Row
                                    className="hotelFinalBooking_guestRow"
                                    key={`room${roomIndex}-adult${adultIndex}`}
                                  >
                                    <Col
                                      sm={2}
                                      className="hotelFinalBooking_guestLabelCol"
                                    >
                                      <label className="hotelFinalBooking_guestLabel">
                                        Adult {adultIndex + 1}
                                      </label>
                                    </Col>
                                    <Col
                                      sm={10}
                                      className="hotelFinalBooking_guestInputsCol"
                                    >
                                      <Row className="hotelFinalBooking_inputRow">
                                        <Col
                                          sm={2}
                                          className="hotelFinalBooking_inputRowCol"
                                        >
                                          <div className="hotelFinalBooking_SelectWrapper">
                                            <select
                                              className={`form-control hotelFinalBooking_input ${
                                                guestInfo[roomIndex]
                                                  .HotelPassenger[adultIndex]
                                                  .Errors.Title
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                              value={
                                                guestInfo[roomIndex]
                                                  .HotelPassenger[adultIndex]
                                                  .Title
                                              }
                                              onChange={(e) =>
                                                handleGuestInputChange(
                                                  roomIndex,
                                                  adultIndex,
                                                  "Title",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <option value="">Title</option>
                                              <option value="Mr">Mr.</option>
                                              <option value="Ms">Ms.</option>
                                              <option value="Mrs">Mrs.</option>
                                            </select>
                                            {guestInfo[roomIndex].HotelPassenger[
                                              adultIndex
                                            ].Errors.Title && (
                                              <div className="invalid-feedback">
                                                {
                                                  guestInfo[roomIndex]
                                                    .HotelPassenger[adultIndex]
                                                    .Errors.Title
                                                }
                                              </div>
                                            )}
                                          </div>
                                        </Col>
                                        <Col
                                          sm={5}
                                          className="hotelFinalBooking_inputRowCol"
                                        >
                                          <input
                                            type="text"
                                            placeholder="First Name"
                                            className={`form-control hotelFinalBooking_input ${
                                              guestInfo[roomIndex].HotelPassenger[
                                                adultIndex
                                              ].Errors.FirstName
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            value={
                                              guestInfo[roomIndex].HotelPassenger[
                                                adultIndex
                                              ].FirstName
                                            }
                                            onChange={(e) =>
                                              handleGuestInputChange(
                                                roomIndex,
                                                adultIndex,
                                                "FirstName",
                                                e.target.value
                                              )
                                            }
                                          />
                                          {guestInfo[roomIndex].HotelPassenger[
                                            adultIndex
                                          ].Errors.FirstName && (
                                            <div className="invalid-feedback">
                                              {
                                                guestInfo[roomIndex]
                                                  .HotelPassenger[adultIndex]
                                                  .Errors.FirstName
                                              }
                                            </div>
                                          )}
                                        </Col>
                                        <Col
                                          sm={5}
                                          className="hotelFinalBooking_inputRowCol"
                                        >
                                          <input
                                            type="text"
                                            placeholder="Last Name"
                                            className={`form-control hotelFinalBooking_input ${
                                              guestInfo[roomIndex].HotelPassenger[
                                                adultIndex
                                              ].Errors.LastName
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            value={
                                              guestInfo[roomIndex].HotelPassenger[
                                                adultIndex
                                              ].LastName
                                            }
                                            onChange={(e) =>
                                              handleGuestInputChange(
                                                roomIndex,
                                                adultIndex,
                                                "LastName",
                                                e.target.value
                                              )
                                            }
                                          />
                                          {guestInfo[roomIndex].HotelPassenger[
                                            adultIndex
                                          ].Errors.LastName && (
                                            <div className="invalid-feedback">
                                              {
                                                guestInfo[roomIndex]
                                                  .HotelPassenger[adultIndex]
                                                  .Errors.LastName
                                              }
                                            </div>
                                          )}
                                        </Col>

                                        {ValidationInfo?.PanMandatory && (
                                          <Col
                                            sm={6}
                                            className="hotelFinalBooking_inputRowCol"
                                          >
                                            <input
                                              type="text"
                                              placeholder="PAN Number"
                                              className="form-control hotelFinalBooking_input"
                                              autoComplete="off"
                                            />
                                          </Col>
                                        )}

                                        {ValidationInfo?.PassportMandatory && (
                                          <Col
                                            sm={6}
                                            className="hotelFinalBooking_inputRowCol"
                                          >
                                            <input
                                              type="text"
                                              placeholder="Passport Number"
                                              className="form-control hotelFinalBooking_input"
                                              autoComplete="off"
                                            />
                                          </Col>
                                        )}
                                      </Row>
                                    </Col>
                                  </Row>
                                );
                              }
                            )}

                            {!ValidationInfo.SamePaxNameAllowed && [...Array(room.children || 0)].map(
                              (_, childIndex) => (
                                <Row
                                  className="hotelFinalBooking_guestRow"
                                  key={`room${roomIndex}-child${childIndex}`}
                                >
                                  <Col
                                    sm={2}
                                    className="hotelFinalBooking_guestLabelCol"
                                  >
                                    <label className="hotelFinalBooking_guestLabel">
                                      Child {childIndex + 1}
                                    </label>
                                  </Col>
                                  <Col
                                    sm={10}
                                    className="hotelFinalBooking_guestInputsCol"
                                  >
                                    <Row className="hotelFinalBooking_inputRow">
                                      <Col
                                        sm={2}
                                        className="hotelFinalBooking_inputRowCol"
                                      >
                                        <div className="hotelFinalBooking_SelectWrapper">
                                          <select
                                            className="form-control hotelFinalBooking_input"
                                            value={
                                              guestInfo[roomIndex]
                                                .HotelPassenger[
                                                (room.adults || 0) + childIndex
                                              ].Title
                                            }
                                            onChange={(e) =>
                                              handleGuestInputChange(
                                                roomIndex,
                                                (room.adults || 0) + childIndex,
                                                "Title",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option value="">Title</option>
                                            <option value="Master">
                                              Master
                                            </option>
                                            <option value="Miss">Miss</option>
                                          </select>
                                        </div>
                                      </Col>
                                      <Col
                                        sm={5}
                                        className="hotelFinalBooking_inputRowCol"
                                      >
                                        <input
                                          type="text"
                                          placeholder="First Name"
                                          className="form-control hotelFinalBooking_input"
                                          value={
                                            guestInfo[roomIndex].HotelPassenger[
                                              (room.adults || 0) + childIndex
                                            ].FirstName
                                          }
                                          onChange={(e) =>
                                            handleGuestInputChange(
                                              roomIndex,
                                              (room.adults || 0) + childIndex,
                                              "FirstName",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Col>
                                      <Col
                                        sm={5}
                                        className="hotelFinalBooking_inputRowCol"
                                      >
                                        <input
                                          type="text"
                                          placeholder="Last Name"
                                          className="form-control hotelFinalBooking_input"
                                          value={
                                            guestInfo[roomIndex].HotelPassenger[
                                              (room.adults || 0) + childIndex
                                            ].LastName
                                          }
                                          onChange={(e) =>
                                            handleGuestInputChange(
                                              roomIndex,
                                              (room.adults || 0) + childIndex,
                                              "LastName",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              )
                            )}
                          </React.Fragment>
                        ))}

                        <Row>
                          <Col sm={2}></Col>
                          <Col
                            sm={10}
                            className="hotelFinalBooking_inputRowCol"
                          >
                            <div
                              className="hotelFinalBooking_bookingDetailsForm"
                              id="contactDetails"
                            >
                              <p className="hotelFinalBooking_font14 hotelFinalBooking_bold appendBottom15">
                                Booking details will be sent to
                              </p>
                            </div>

                            <Row className="hotelFinalBooking_adultItemRow">
                              <Col
                                sm={2}
                                xs={4}
                                className="hotelFinalBooking_inputRowCol"
                              >
                                <div className="hotelFinalBooking_adultItem">
                                  <div className="hotelFinalBooking_selectItem">
                                    <select className="form-control hotelFinalBooking_input">
                                      <option>India (+91)</option>
                                      <option>United States (+1)</option>
                                      <option>United Kingdom (+44)</option>
                                    </select>
                                  </div>
                                </div>
                              </Col>

                              <Col
                                sm={5}
                                xs={8}
                                className="hotelFinalBooking_inputRowCol"
                              >
                                <div className="hotelFinalBooking_adultItem">
                                  <input
                                    className="form-control hotelFinalBooking_input"
                                    type="text"
                                    placeholder="Contact No"
                                    value={contactNumber}
                                    onChange={(e) =>
                                      setContactNumber(e.target.value)
                                    }
                                  />
                                </div>
                              </Col>

                              <Col sm={5} xs={12}>
                                <div className="hotelFinalBooking_adultItem">
                                  <input
                                    className="form-control hotelFinalBooking_input"
                                    type="text"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                </div>
                              </Col>
                            </Row>
                            {/* <Col  className="hotelFinalBooking_inputRowCol">
                                    <input type="text" placeholder="PanMandatory" className="form-control hotelFinalBooking_input" autoComplete="off" />
                                  </Col> */}

                            <div className="hotelFinalBooking_gstSection">
                              <label className="hotelFinalBooking_checkboxContainer">
                                <input
                                  type="checkbox"
                                  checked={showGSTFields}
                                  onChange={handleGSTCheckboxChange}
                                />
                                <span className="hotelFinalBooking_checkboxLabel">
                                  <span className="hotelFinalBooking_boldFont">
                                    I have a GST number{" "}
                                    <span style={{ color: "#9b9b9b" }}>
                                      (Optional)
                                    </span>
                                  </span>
                                </span>
                              </label>

                              {showGSTFields && (
                                <div className="hotelFinalBooking_gstFields">
                                  <Row className="hotelFinalBooking_adultItemRow">
                                    <Col sm={6}>
                                      <label className="hotelFinalBooking_label">
                                        Company Name
                                      </label>
                                      <input
                                        className="form-control hotelFinalBooking_input"
                                        type="text"
                                        placeholder="Company Name"
                                      />
                                    </Col>
                                    <Col
                                      sm={6}
                                      className="hotelFinalBooking_inputRowCol"
                                    >
                                      <label className="hotelFinalBooking_label">
                                        GST No
                                      </label>
                                      <input
                                        className="form-control hotelFinalBooking_input"
                                        type="text"
                                        placeholder="GST No"
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="hotelFinalBooking_priceSummary">
                        <div className="hotelFinalBooking_fareSummary">
                          <div>Fare Summary</div>
                          {/* <div>1 Guest</div> */}
                        </div>
                        <div className="hotelFinalBooking_BasefareSummary">
                          <div>Room Rate -</div>
                          <div>
                            ₹{" "}
                            {Math.round(
                              hotelPreBookData?.data?.HotelResult?.[0]?.Rooms?.[0]?.PriceBreakUp?.reduce(
                                (total, price) =>
                                  total + (price?.RoomRate || 0),
                                0
                              ) || 0
                            )}
                          </div>
                        </div>
                        <div className="hotelFinalBooking_BasefareSummary">
                          <div>Room Tax -</div>
                          <div>
                            ₹{" "}
                            {Math.round(
                              hotelPreBookData?.data?.HotelResult?.[0]?.Rooms?.[0]?.PriceBreakUp?.reduce(
                                (total, price) =>
                                  total +
                                  ((price?.RoomTax || 0) -
                                    (price?.AgentCommission || 0)),
                                0
                              ) || 0
                            )}
                          </div>
                        </div>

                        {selectedCoupon?.discount > 0 && (
                          <div className="hotelFinalBooking_BasefareSummary">
                            <div>Discount -</div>
                            <div>₹ {Math.round(selectedCoupon.discount)}</div>
                          </div>
                        )}

                        <div className="hotelFinalBooking_PayAmt">
                          <div>You Pay: -</div>
                          <div>
                            ₹
                            {Math.round(
                              (hotelPreBookData?.data?.HotelResult[0]?.Rooms[0]
                                ?.NetAmount || 0) -
                                (selectedCoupon ? selectedCoupon.discount : 0)
                            )}
                          </div>
                        </div>
                        {/* <button onClick={handleHotelBookNow} className="hotelFinalBooking_continueBtn">Continue</button> */}
                        <button
                          onClick={() => setShowReviewModal(true)}
                          className="hotelFinalBooking_continueBtn"
                        >
                          Continue
                        </button>
                      </div>
                      <div>
                        <PromoCode
                          availableCoupons={coupons}
                          onSelectCoupon={(coupon) => setSelectedCoupon(coupon)}
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>

          <div className="hotelPreBook-Mobile">
            <div className="hotelPreBookMobile-wrapper">
              <div className="hotelPreBookMobile-header">
                <Link to="/hoteldetailmain">
                  <FaArrowLeft className="hotelback-icon" />
                </Link>
                <span className="hotelPreBookMobile-headerText">
                  Hotel Review & Traveller
                </span>
              </div>

              <div className="hotelPreBookMobile-card">
                <div className="hotelPreBookMobile-titleRow">
                  <div className="hotel-DetailMobile-hotelName">
                    <div className="hotelListingstyling-name hotelFinalBooking-name">
                      {hotelPreBookData?.data?.HotelDetail?.name}
                      <div
                        className="rating-score"
                        style={{ textAlign: "center", fontSize: "18px" }}
                      >
                        {[...Array(5)].map((_, index) => (
                          <span
                            key={index}
                            style={{
                              color:
                                index <
                                Number(
                                  hotelPreBookData?.data?.HotelDetail
                                    ?.star_rating
                                )
                                  ? "#FFD700"
                                  : "#ccc",
                            }}
                          >
                            ★
                          </span>
                        ))}
                      </div>
                      <div className="hotel-Address hotel-AddressMobile">
                        <CiLocationOn />{" "}
                        <span>
                          {hotelPreBookData?.data?.HotelDetail?.address}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <hr className="hotelPreBookMobile-divider" />

                <div className="hotelPreBookMobile-roomRow">
                  <div className="hotelPreBookMobile-roomInfo">
                    <h4 className="hotelPreBookMobile-roomTitle">
                      {hotelPreBookData?.data?.rooms[0]?.Name}
                    </h4>
                    <ul className="hotelPreBookMobile-roomList">
                      <li>Breakfast not included Welcome Drink</li>
                      <li>
                        10% Discount on Food & Soft Beverages…{" "}
                        <span className="hotelPreBookMobile-viewMore">
                          View more
                        </span>
                      </li>
                    </ul>
                    <div className="hotelPreBookMobile-guestInfo">
                      <span>
                        <span style={{ fontWeight: "bold" }}>
                          {(roomsConfig || []).reduce(
                            (acc, r) =>
                              acc + (r?.adults || 0) + (r?.children || 0),
                            0
                          )}
                        </span>{" "}
                        Guests
                      </span>{" "}
                      |{" "}
                      <span>
                        <span style={{ fontWeight: "bold" }}>
                          {roomsConfig?.length || 0}
                        </span>{" "}
                        Rooms
                      </span>
                    </div>
                  </div>
                  <div className="hotelPreBookMobile-roomImage">
                    <img
                      src={
                        hotelPreBookData?.data?.HotelDetail?.images?.[0] ||
                        "https://cdn01.metrotvnews.com/dynamic/content/2025/05/13/ba4CzPQY/a_6822c7db85750.jpg?w=720"
                      }
                      alt="Room"
                    />
                  </div>
                </div>

                <div className="hotelPreBookMobile-dashedDivider"></div>

                <h4 className="hotelPreBookMobile-sectionTitle">
                  Travel Dates and Guests
                </h4>

                <div className="hotelPreBookMobile-dateBox">
                  <div className="hotelPreBookMobile-dateItem">
                    <p className="hotelPreBookMobile-dateLabel">Check-In</p>
                    <p className="hotelPreBookMobile-dateDay">
                      {checkIn
                        ? new Date(checkIn).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : ""}
                    </p>
                  </div>
                  <div className="hotelPreBookMobile-nightCircle">1N</div>
                  <div className="hotelPreBookMobile-dateItem">
                    <p className="hotelPreBookMobile-dateLabel">Check-Out</p>
                    <p className="hotelPreBookMobile-dateDay">
                      {checkOut
                        ? new Date(checkOut).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : ""}
                    </p>
                    {/* <p className="hotelPreBookMobile-dateTime">12:00 PM</p> */}
                  </div>
                </div>

                <p className="hotelPreBookMobile-inclusionsLink">Inclusions</p>
              </div>
            </div>

            <div className="hotelTravellerMobile-wrapper">
              <div className="hotelPreBookMobile-priceCard">
                <h4 className="hotelPreBookMobile-sectionTitle">
                  Price Breakup
                </h4>
                <p className="hotelPreBookMobile-priceSubtitle">
                  A detailed breakdown of costs associated with hotel
                </p>
                <hr className="hotelPreBookMobile-divider" />

                <div className="hotelPreBookMobile-priceRow">
                  <span>Base Fare -</span>
                  <span>
                    ₹{" "}
                    {Math.round(
                      hotelPreBookData?.data?.rooms?.[0]?.TotalFare || 0
                    )}
                  </span>
                </div>
                <div className="hotelPreBookMobile-priceRow">
                  <span>Taxes & Surcharges -</span>
                  <span>
                    ₹{" "}
                    {Math.round(
                      hotelPreBookData?.data?.rooms?.[0]?.TotalTax || 0
                    )}
                  </span>
                </div>
                <div className="hotelPreBookMobile-priceRow">
                  <span>Discount -</span>
                  <span>₹ 0</span>
                </div>
                <div className="hotelPreBookMobile-grandTotal">
                  <span>You Pay: -</span>
                  <span className="hotelPreBookMobile-grandTotalAmount">
                    ₹{" "}
                    {Math.round(
                      (hotelPreBookData?.data?.HotelResult[0]?.Rooms[0]
                        ?.NetAmount || 0) -
                        (selectedCoupon ? selectedCoupon.discount : 0)
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="hotelTravellerMobile-wrapper">
              <div className="hotelTravellerMobile-card">
                <h4 className="hotelTravellerMobile-title">
                  Traveller Details
                </h4>
                <p className="hotelTravellerMobile-subtitle">
                  Enter your details as per your Aadhar Card
                </p>

                {roomsConfig.map((room, roomIndex) => (
                  <div key={roomIndex} className="hotelTravellerMobile-roomGroup" style={{ marginBottom: "20px" }}>
                    <h5 className="hotelTravellerMobile-roomSubTitle" style={{ fontSize: "16px", fontWeight: "bold", color: "#1d489f", marginBottom: "10px" }}>
                      Room {roomIndex + 1}
                    </h5>
                    
                    {[...Array(room.adults || 0)].map((_, adultIndex) => {
                      if (ValidationInfo.SamePaxNameAllowed && adultIndex > 0) return null;
                      return (
                        <div key={`adult-${adultIndex}`} className="hotelTravellerMobile-paxInfo" style={{ marginBottom: "15px" }}>
                          <p style={{ fontWeight: "600", fontSize: "14px", marginBottom: "5px" }}>Adult {adultIndex + 1}</p>
                          <div className="hotelTravellerMobile-row">
                            <div className="hotelTravellerMobile-inputGroup">
                              <label>Title</label>
                              <select
                                value={guestInfo[roomIndex]?.HotelPassenger[adultIndex]?.Title || ""}
                                onChange={(e) => handleGuestInputChange(roomIndex, adultIndex, "Title", e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Ms">Ms</option>
                              </select>
                            </div>
                            <div className="hotelTravellerMobile-inputGroup">
                              <label>First Name</label>
                              <input
                                type="text"
                                placeholder="First Name"
                                className={guestInfo[roomIndex]?.HotelPassenger[adultIndex]?.Errors?.FirstName ? "is-invalid" : ""}
                                value={guestInfo[roomIndex]?.HotelPassenger[adultIndex]?.FirstName || ""}
                                onChange={(e) => handleGuestInputChange(roomIndex, adultIndex, "FirstName", e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="hotelTravellerMobile-inputGroup">
                            <label>Last Name</label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              className={guestInfo[roomIndex]?.HotelPassenger[adultIndex]?.Errors?.LastName ? "is-invalid" : ""}
                              value={guestInfo[roomIndex]?.HotelPassenger[adultIndex]?.LastName || ""}
                              onChange={(e) => handleGuestInputChange(roomIndex, adultIndex, "LastName", e.target.value)}
                            />
                          </div>
                        </div>
                      );
                    })}

                    {!ValidationInfo.SamePaxNameAllowed && [...Array(room.children || 0)].map((_, childIndex) => {
                      const paxIdx = (room.adults || 0) + childIndex;
                      return (
                        <div key={`child-${childIndex}`} className="hotelTravellerMobile-paxInfo" style={{ marginBottom: "15px" }}>
                          <p style={{ fontWeight: "600", fontSize: "14px", marginBottom: "5px" }}>Child {childIndex + 1}</p>
                          <div className="hotelTravellerMobile-row">
                            <div className="hotelTravellerMobile-inputGroup">
                              <label>Title</label>
                              <select
                                value={guestInfo[roomIndex]?.HotelPassenger[paxIdx]?.Title || ""}
                                onChange={(e) => handleGuestInputChange(roomIndex, paxIdx, "Title", e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="Master">Master</option>
                                <option value="Miss">Miss</option>
                              </select>
                            </div>
                            <div className="hotelTravellerMobile-inputGroup">
                              <label>First Name</label>
                              <input
                                type="text"
                                placeholder="First Name"
                                value={guestInfo[roomIndex]?.HotelPassenger[paxIdx]?.FirstName || ""}
                                onChange={(e) => handleGuestInputChange(roomIndex, paxIdx, "FirstName", e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="hotelTravellerMobile-inputGroup">
                            <label>Last Name</label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              value={guestInfo[roomIndex]?.HotelPassenger[paxIdx]?.LastName || ""}
                              onChange={(e) => handleGuestInputChange(roomIndex, paxIdx, "LastName", e.target.value)}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>

              <h4 className="hotelTravellerMobile-subsection">
                Contact Information
              </h4>

              <div className="hotelTravellerMobile-inputGroup">
                <label>Email Id</label>
                <input
                  type="email"
                  placeholder="Please Enter Email Id"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="hotelTravellerMobile-row">
                <div className="hotelTravellerMobile-inputGroup">
                  <label>Mobile No</label>
                  <div className="hotelTravellerMobile-mobileRow">
                    <select>
                      <option>+91</option>
                      <option>+1</option>
                      <option>+44</option>
                    </select>
                    <input
                      type="text"
                      placeholder="Please Enter Mobile No"
                      value={contactNumber}
                      onChange={(e) => setContactNumber(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "80px" }}>
                <PromoCode
                  availableCoupons={coupons}
                  onSelectCoupon={(coupon) => setSelectedCoupon(coupon)}
                />
              </div>
              <div className="hotelTravellerMobile-priceBar">
                <div>
                  <div className="hotelPreBookMobile-guestInfo">
                    <span>
                      <span style={{ fontWeight: "bold" }}>
                        {(roomsConfig || []).reduce(
                          (acc, r) =>
                            acc + (r?.adults || 0) + (r?.children || 0),
                          0
                        )}
                      </span>{" "}
                      Guests
                    </span>{" "}
                    |{" "}
                    <span>
                      <span style={{ fontWeight: "bold" }}>
                        {roomsConfig?.length || 0}
                      </span>{" "}
                      Rooms
                    </span>
                  </div>
                  <strong style={{ color: "#878787" }}>
                    ₹{" "}
                    {Math.round(
                      (hotelPreBookData?.data?.HotelResult[0]?.Rooms[0]
                        ?.NetAmount || 0) -
                        (selectedCoupon ? selectedCoupon.discount : 0)
                    )}
                  </strong>
                </div>
                {/* <button onClick={handleHotelBookNow}>Continue</button> */}
                <button
                  onClick={() => setShowReviewModalMobile(true)}
                  className="hotelFinalBooking_continueBtn"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>

          {showReviewModalMobile && (
            <HotelReviewPageMobile
              setReviewModal={setShowReviewModalMobile}
              handleConfirmClick={() => {
                setShowReviewModalMobile(false);
                handleHotelBookNow();
              }}
              formData={guestInfo.flatMap((r) => {
                if (ValidationInfo.SamePaxNameAllowed) {
                  return [r.HotelPassenger[0]];
                }
                return r.HotelPassenger.filter((p) => p.PaxType === 1);
              })}
              childData={guestInfo.flatMap((r) => {
                if (ValidationInfo.SamePaxNameAllowed) {
                  return [];
                }
                return r.HotelPassenger.filter((p) => p.PaxType === 2);
              })}
            />
          )}

          {showReviewModal && (
            <HotelReviewPage
              setReviewModal={setShowReviewModal}
              handleConfirmClick={() => {
                setShowReviewModal(false);
                handleHotelBookNow();
              }}
              formData={guestInfo.flatMap((r) => {
                if (ValidationInfo.SamePaxNameAllowed) {
                  return [r.HotelPassenger[0]];
                }
                return r.HotelPassenger.filter((p) => p.PaxType === 1);
              })}
              childData={guestInfo.flatMap((r) => {
                if (ValidationInfo.SamePaxNameAllowed) {
                  return [];
                }
                return r.HotelPassenger.filter((p) => p.PaxType === 2);
              })}
            />
          )}

          {paymentInitializing && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9998,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "16px 20px",
                  borderRadius: 8,
                  boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <span
                  className="spinner-border"
                  role="status"
                  aria-hidden="true"
                  style={{ width: 24, height: 24 }}
                ></span>
                <span style={{ fontWeight: 600 }}>
                  Initializing secure payment…
                </span>
              </div>
            </div>
          )}

          {bookingProcessing && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "24px 32px",
                  borderRadius: 12,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 16,
                  maxWidth: "400px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: 48,
                    height: 48,
                    border: "4px solid #f3f3f3",
                    borderTop: "4px solid #1d489f",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
                <div>
                  <h4
                    style={{
                      margin: "0 0 8px 0",
                      color: "#333",
                      fontSize: "18px",
                    }}
                  >
                    Please wait...
                  </h4>
                  <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>
                    Your booking is almost done! We're processing your
                    reservation.
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <HotelFinalBookingSkeleton />
      )}
    </div>
  );
};

export default HotelFinalBooking;
